import React, { Component } from 'react'
import { bool, func, number, string } from 'prop-types'
import { connect } from 'react-redux'

import { productDataType } from 'models/propTypes'
import { FURNITURE_ITEM } from 'constants/renderItemTypes'
import { selectFurniture, selectSwapFurnitureForDetails } from 'models/furniture/actions'
import { setDesignSidepanelMode } from 'models/ui/actions'
import * as modes from 'models/ui/constants'
import { getSelectedCompositionId, getSelectedRenderItemId } from 'models/compositions/selectors'
import { clickPlaceRenderItem, selectCompositionRenderItem, swapRenderItem } from 'models/compositions/actions'
import { addToBag as addToBagAction } from 'models/bag/actions'
import {
    GET_INFO_CATALOG_LIST,
    GET_INFO_SWAP_LIST,
    GET_INFO_ROOM_LIST,
    GET_INFO_FAVORITES_LIST,
    PRODUCT_SWAP,
} from 'models/tracking/constants'
import { getDesignSidepanelMode, getShowDesignSummary } from 'models/ui/selectors'
import ProductItem from 'components/designSidepanel/ProductItem'
import ProductItemWide from 'components/designSidepanel/ProductItemWide'
import ProductItemInSwap from 'components/designSidepanel/ProductItemInSwap'
import { getSelectedFurnitureData, getSelectedSwapFurnitureData } from 'models/furniture/selectors'
import { getProductTrackingInfo } from 'models/tracking/utils'

import SugarcubeContext from 'apps/SugarcubeContext'

import classNames from 'classnames'

class ProductItemContainer extends Component {
    constructor(props) {
        super(props)
        this.onSelect = this.onSelect.bind(this)
        this.addToRoom = this.addToRoom.bind(this)
        this.viewDetails = this.viewDetails.bind(this)
        this.addToBag = this.addToBag.bind(this)
        this.onSwap = this.onSwap.bind(this)
        this.onUndoSwap = this.onUndoSwap.bind(this)
    }

    onSelect() {
        const {
            onSelect,
            furnitureData: { id: furnitureDataId, uniqueId },
            mode,
            selectItem,
        } = this.props
        const isInMyItems = mode === modes.DESIGN_SIDEPANEL_MODE_MYITEMS_BROWSE

        onSelect(furnitureDataId)
        if (isInMyItems) {
            if (uniqueId) {
                selectItem(uniqueId)
            }
        }
    }

    onSwap(e) {
        e.stopPropagation()
        const { onSwap, selectedId: removedFurnitureId, selectedFurnitureData, furnitureData } = this.props
        const { id: swappedFurnitureId } = furnitureData
        const swappedInProductTrackingInfo = getProductTrackingInfo(furnitureData)
        const swappedInTrackingInfo = {
            ...swappedInProductTrackingInfo,
            AddedFrom: PRODUCT_SWAP,
        }

        if (removedFurnitureId) {
            const removedProductTrackingInfo = getProductTrackingInfo(selectedFurnitureData)
            const removedTrackingInfo = {
                ...removedProductTrackingInfo,
                RemovedFrom: PRODUCT_SWAP,
            }

            const trackingInfo = {
                swappedInTrackingInfo,
                removedTrackingInfo,
            }
            onSwap(removedFurnitureId, swappedFurnitureId, trackingInfo)
        }
    }

    onUndoSwap(e) {
        e.stopPropagation()
        const { onSwap, selectedId: removedFurnitureId, selectedFurnitureData, selectedSwapFurnitureData } = this.props
        // Swap back the original product, the swap anchor
        if (selectedFurnitureData && selectedSwapFurnitureData) {
            const swappedInProductTrackingInfo = getProductTrackingInfo(selectedSwapFurnitureData)
            const { id: swappedFurnitureId } = selectedSwapFurnitureData
            const swappedInTrackingInfo = {
                ...swappedInProductTrackingInfo,
                AddedFrom: PRODUCT_SWAP,
            }

            if (removedFurnitureId) {
                const removedProductTrackingInfo = getProductTrackingInfo(selectedFurnitureData)
                const removedTrackingInfo = {
                    ...removedProductTrackingInfo,
                    RemovedFrom: PRODUCT_SWAP,
                }

                const trackingInfo = {
                    swappedInTrackingInfo,
                    removedTrackingInfo,
                }
                onSwap(removedFurnitureId, swappedFurnitureId, trackingInfo)
            }
        }
    }

    addToRoom() {
        const { furnitureData: productData, compositionId, addProductToRoom, trackingInfoAddedFrom } = this.props
        const { id, stacks, renderType, hidden } = productData
        let renderData
        if (renderType === FURNITURE_ITEM) {
            renderData = {
                heading: 0,
                stacks,
                hidden,
            }
        } else {
            // For Art
            renderData = {
                matteId: 1,
                frameId: 1,
                sizeId: 1,
                colorId: 1,
                customHeight: null,
            }
        }
        const productTrackingInfo = getProductTrackingInfo(productData)
        addProductToRoom(
            compositionId,
            id,
            {
                renderType,
                ...renderData,
            },
            {
                ...productTrackingInfo,
                AddedFrom: trackingInfoAddedFrom,
            },
        )
        this.onSelect()
    }

    addToBag() {
        const { furnitureData, addToBag } = this.props
        const { localItemNumber, region } = furnitureData
        const { name: productTitle } = furnitureData

        const trackingInfo = getProductTrackingInfo(furnitureData)
        addToBag(localItemNumber, region, productTitle, trackingInfo)
    }

    viewDetails() {
        const { setMode, mode, furnitureData, selectSwapItemForDetails } = this.props

        const isInMyItems = mode === modes.DESIGN_SIDEPANEL_MODE_MYITEMS_BROWSE
        const isInFavorites = mode === modes.DESIGN_SIDEPANEL_MODE_FAVORITES_BROWSE
        const isInSwap = mode === modes.DESIGN_SIDEPANEL_MODE_SWAP_BROWSE

        const { id } = furnitureData

        const trackingInfo = getProductTrackingInfo(furnitureData)

        if (isInMyItems) {
            setMode(modes.DESIGN_SIDEPANEL_MODE_MYITEMS_DETAILS, { ...trackingInfo, AccessFrom: GET_INFO_ROOM_LIST })
        } else if (isInFavorites) {
            setMode(modes.DESIGN_SIDEPANEL_MODE_FAVORITES_DETAILS, {
                ...trackingInfo,
                AccessFrom: GET_INFO_FAVORITES_LIST,
            })
        } else if (isInSwap) {
            selectSwapItemForDetails(id)
            setMode(modes.DESIGN_SIDEPANEL_MODE_SWAP_DETAILS, { ...trackingInfo, AccessFrom: GET_INFO_SWAP_LIST })
        } else {
            setMode(modes.DESIGN_SIDEPANEL_MODE_PRODUCT_DETAILS, { ...trackingInfo, AccessFrom: GET_INFO_CATALOG_LIST })
        }
    }

    render() {
        const { furnitureData, mode, selectedFurnitureData, isDesignSummaryVisible } = this.props
        const isInMyItems = mode === modes.DESIGN_SIDEPANEL_MODE_MYITEMS_BROWSE
        const isInFavorites = mode === modes.DESIGN_SIDEPANEL_MODE_FAVORITES_BROWSE
        const isInSwap = mode === modes.DESIGN_SIDEPANEL_MODE_SWAP_BROWSE
        const { isMobile = false } = this.context

        if (isInMyItems || isInFavorites || isDesignSummaryVisible) {
            return (
                <div className="ProductItemContainer oneColumn" data-testid="product-item">
                    <ProductItemWide
                        productData={furnitureData}
                        onSelect={this.onSelect}
                        viewDetails={isDesignSummaryVisible ? null : this.viewDetails}
                        addToBag={this.addToBag}
                        addToRoom={isInFavorites ? this.addToRoom : null}
                    />
                </div>
            )
        }
        if (isInSwap) {
            const threeColumns = !isMobile
            return (
                <div className={classNames('ProductItemContainer', { threeColumns })} data-testid="product-item">
                    <ProductItemInSwap
                        swappableItemData={furnitureData}
                        onSelect={this.onSelect}
                        onSwap={this.onSwap}
                        viewDetails={this.viewDetails}
                        selectedFurnitureData={selectedFurnitureData}
                        onUndoSwap={this.onUndoSwap}
                    />
                </div>
            )
        }
        return (
            <div className="ProductItemContainer threeColumns" data-testid="product-item">
                <ProductItem
                    furnitureData={furnitureData}
                    onSelect={this.onSelect}
                    addToRoom={this.addToRoom}
                    viewDetails={this.viewDetails}
                />
            </div>
        )
    }
}

ProductItemContainer.contextType = SugarcubeContext
ProductItemContainer.defaultProps = {
    selectedFurnitureData: null,
    selectedId: null,
    selectedSwapFurnitureData: null,
    trackingInfoAddedFrom: null,
}

ProductItemContainer.propTypes = {
    furnitureData: productDataType.isRequired,
    onSelect: func.isRequired,
    compositionId: number.isRequired,
    addProductToRoom: func.isRequired,
    setMode: func.isRequired,
    selectItem: func.isRequired,
    trackingInfoAddedFrom: string,
    addToBag: func.isRequired,
    mode: string.isRequired,
    selectedFurnitureData: productDataType,
    onSwap: func.isRequired,
    selectedId: number,
    selectSwapItemForDetails: func.isRequired,
    selectedSwapFurnitureData: productDataType,
    isDesignSummaryVisible: bool.isRequired,
}

const mapStateToProps = (state) => ({
    compositionId: getSelectedCompositionId(state),
    mode: getDesignSidepanelMode(state),
    selectedFurnitureData: getSelectedFurnitureData(state),
    selectedId: getSelectedRenderItemId(state),
    selectedSwapFurnitureData: getSelectedSwapFurnitureData(state),
    isDesignSummaryVisible: getShowDesignSummary(state),
})

const mapDispatchToProps = {
    addProductToRoom: clickPlaceRenderItem,
    onSelect: selectFurniture,
    setMode: setDesignSidepanelMode,
    selectItem: selectCompositionRenderItem,
    addToBag: addToBagAction,
    onSwap: swapRenderItem,
    selectSwapItemForDetails: selectSwapFurnitureForDetails,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductItemContainer)
